const getStringWithSeparators = (
  array: (string | null | undefined | boolean)[],
  separator = '・'
) => array.filter(value => !!value).join(separator);

export default getStringWithSeparators;
